import { NgModule } from '@angular/core';
import { FiStartPageLayoutComponent } from './start-page-layout.component';
import { CommonModule } from '@angular/common';
import { WidgetModule } from '@fi-app/widget/widget.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiOnboardingHomePageModule } from '@fi-app/fi-onboarding/fi-onboarding-home-page/fi-onboarding-home-page.module';

@NgModule({
    imports: [CommonModule, WidgetModule, FiAppTextSharedModule, FiWhenScrolledModule, FiOnboardingHomePageModule],
    declarations: [FiStartPageLayoutComponent],
    exports: [FiStartPageLayoutComponent],
})
export class FiStartPageLayoutModule {}
